import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#enrollment_summary",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Institute Wise Enrollment Summary")
  ])
], -1)
const _hoisted_3 = {
  id: "enrollment_summary",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-5 pb-0" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Tranche", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Institutes", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_19 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_20 = { class: "nav-item" }
const _hoisted_21 = { class: "nav-item" }
const _hoisted_22 = { class: "card-body" }
const _hoisted_23 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_24 = { class: "card-header border-0 pt-6 px-0 mx-0" }
const _hoisted_25 = { class: "card-title" }
const _hoisted_26 = { class: "d-flex align-items-center position-relative" }
const _hoisted_27 = { class: "card mb-5 mb-xl-10" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#association_institute_summary",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_29 = {
  id: "association_institute_summary",
  class: "collapse show"
}
const _hoisted_30 = { class: "collapse show" }
const _hoisted_31 = { class: "card-body border-top p-6" }
const _hoisted_32 = { class: "table-responsive mt-5" }
const _hoisted_33 = { class: "table table-borderless gy-4" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"180px"} }, "Institute Name"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Enrollment"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Female Enrollment"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Completed Count"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Assessed Female Count"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Certification Count"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Certified Female"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Employment Count"),
    /*#__PURE__*/_createElementVNode("th", { style: {"color":"black","font-weight":"bold"} }, "Employed Female")
  ])
], -1)
const _hoisted_35 = { style: {} }
const _hoisted_36 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_37 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_38 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_39 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_40 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_41 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_42 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_43 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_44 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_45 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_46 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_47 = { class: "align-middle" }
const _hoisted_48 = { class: "align-middle" }
const _hoisted_49 = { class: "align-middle" }
const _hoisted_50 = { class: "align-middle" }
const _hoisted_51 = { class: "align-middle" }
const _hoisted_52 = { class: "align-middle" }
const _hoisted_53 = { class: "align-middle" }
const _hoisted_54 = { class: "align-middle" }
const _hoisted_55 = { class: "align-middle" }
const _hoisted_56 = { class: "align-middle" }
const _hoisted_57 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Total", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, null, -1)
const _hoisted_60 = { class: "font-weight-bold" }
const _hoisted_61 = { class: "font-weight-bold" }
const _hoisted_62 = { class: "font-weight-bold" }
const _hoisted_63 = { class: "font-weight-bold" }
const _hoisted_64 = { class: "font-weight-bold" }
const _hoisted_65 = { class: "font-weight-bold" }
const _hoisted_66 = { class: "font-weight-bold" }
const _hoisted_67 = { class: "font-weight-bold" }
const _hoisted_68 = { class: "card-body" }
const _hoisted_69 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_70 = { class: "card-header border-0 pt-6 px-0 mx-0" }
const _hoisted_71 = { class: "card-title" }
const _hoisted_72 = { class: "d-flex align-items-center position-relative" }
const _hoisted_73 = { class: "card mb-7" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#association_institute_course_summary",
  "aria-expanded": "true",
  "aria-controls": "form"
}, null, -1)
const _hoisted_75 = {
  id: "association_institute_course_summary",
  class: "collapse show"
}
const _hoisted_76 = { class: "collapse show" }
const _hoisted_77 = { class: "card-body border-top p-6" }
const _hoisted_78 = { class: "table-responsive mt-5" }
const _hoisted_79 = { class: "table table-borderless gy-4" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "BN"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center",
      colspan: "2",
      style: {"width":"180px"}
    }, "Date"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center",
      colspan: "2"
    }, "Enrollment"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center",
      colspan: "2"
    }, "Completed Count"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center",
      colspan: "2"
    }, "Certification Count"),
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center",
      colspan: "2"
    }, "Employment Count")
  ]),
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-primary" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Strat"),
    /*#__PURE__*/_createElementVNode("th", null, "End"),
    /*#__PURE__*/_createElementVNode("th", null, "All"),
    /*#__PURE__*/_createElementVNode("th", null, "Female"),
    /*#__PURE__*/_createElementVNode("th", null, "All"),
    /*#__PURE__*/_createElementVNode("th", null, "Female"),
    /*#__PURE__*/_createElementVNode("th", null, "All"),
    /*#__PURE__*/_createElementVNode("th", null, "Female"),
    /*#__PURE__*/_createElementVNode("th", null, "All"),
    /*#__PURE__*/_createElementVNode("th", null, "Female")
  ])
], -1)
const _hoisted_81 = { style: {} }
const _hoisted_82 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_83 = {
  colspan: "11",
  class: "font-weight-bold text-primary align-middle"
}
const _hoisted_84 = { class: "align-middle" }
const _hoisted_85 = { class: "align-middle" }
const _hoisted_86 = { class: "align-middle" }
const _hoisted_87 = { class: "align-middle" }
const _hoisted_88 = { class: "align-middle" }
const _hoisted_89 = { class: "align-middle" }
const _hoisted_90 = { class: "align-middle" }
const _hoisted_91 = { class: "align-middle" }
const _hoisted_92 = { class: "align-middle" }
const _hoisted_93 = { class: "align-middle" }
const _hoisted_94 = { class: "align-middle" }
const _hoisted_95 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "font-weight-bold text-primary"
}, "Total", -1)
const _hoisted_97 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_98 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_99 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_100 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_101 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_102 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_103 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_104 = { class: "font-weight-bold text-primary align-middle" }
const _hoisted_105 = { style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_106 = /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "font-weight-bold text-primary"
}, "Grand Total", -1)
const _hoisted_107 = { class: "font-weight-bold text-primary" }
const _hoisted_108 = { class: "font-weight-bold text-primary" }
const _hoisted_109 = { class: "font-weight-bold text-primary" }
const _hoisted_110 = { class: "font-weight-bold text-primary" }
const _hoisted_111 = { class: "font-weight-bold text-primary" }
const _hoisted_112 = { class: "font-weight-bold text-primary" }
const _hoisted_113 = { class: "font-weight-bold text-primary" }
const _hoisted_114 = { class: "font-weight-bold text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.trainee.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.trainee.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: trans.id,
                            label: trans.label,
                            value: trans.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(trans.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _hoisted_14,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Partner",
                      modelValue: _ctx.trainee.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.trainee.entity_id) = $event)),
                      filterable: "",
                      onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trainingInstitute())),
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.associations, (assoc) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: assoc.id,
                            label: assoc.entity_short_name,
                            value: assoc.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("[" + _toDisplayString(assoc.entity_short_name) + "]-" + _toDisplayString(assoc.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.trainee.training_institute_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.trainee.training_institute_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.institutes, (inst) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: inst.id,
                            label: inst.institute_name,
                            value: inst.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(inst.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("ul", _hoisted_19, [
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 1 }]),
                      "data-bs-toggle": "tab",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setActiveTab($event))),
                      "data-tab-index": "1",
                      href: "#institute_summary",
                      role: "tab"
                    }, " Show Institute Summary ", 2)
                  ]),
                  _createElementVNode("li", _hoisted_21, [
                    _createElementVNode("a", {
                      class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 2 }]),
                      "data-bs-toggle": "tab",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setActiveTab($event))),
                      "data-tab-index": "2",
                      href: "#course_batch_summary",
                      role: "tab"
                    }, " Show Course->Batch Summary ", 2)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.tabIndex === 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: _ctx.enComponentKey,
          class: "card"
        }, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 1 }]),
                id: "institute_summary"
              }, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("h4", null, "Association-Institute->Course Training Summary (Training Institute Found: " + _toDisplayString(_ctx.instituteSummary.length) + ")", 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          (_openBlock(), _createElementBlock("div", {
                            class: "current",
                            "data-kt-stepper-element": "content",
                            key: _ctx.institutekey
                          }, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("table", _hoisted_33, [
                                _hoisted_34,
                                _createElementVNode("tbody", _hoisted_35, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteSummary, (data, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      _createElementVNode("tr", _hoisted_36, [
                                        _createElementVNode("th", _hoisted_37, _toDisplayString(index+1), 1),
                                        _createElementVNode("th", _hoisted_38, _toDisplayString(data?.institute_info?.institute_name), 1),
                                        _createElementVNode("th", _hoisted_39, _toDisplayString(Number(data?.enroll_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_40, _toDisplayString(Number(data?.enroll_female_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_41, _toDisplayString(Number(data?.assessed_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_42, _toDisplayString(Number(data?.assessed_female_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_43, _toDisplayString(Number(data?.certification_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_44, _toDisplayString(Number(data?.certification_female_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_45, _toDisplayString(Number(data?.employment_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_46, _toDisplayString(Number(data?.employment_female_trainee).toLocaleString()), 1)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.course_summary, (info, inx) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: inx,
                                          style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"}
                                        }, [
                                          _createElementVNode("th", _hoisted_47, _toDisplayString(index+1) + "." + _toDisplayString(inx+1), 1),
                                          _createElementVNode("th", _hoisted_48, _toDisplayString(info?.course_info?.course_name) + " (" + _toDisplayString(info?.course_info?.tranche_info?.short_name) + ")", 1),
                                          _createElementVNode("th", _hoisted_49, _toDisplayString(info?.enroll_trainee), 1),
                                          _createElementVNode("th", _hoisted_50, _toDisplayString(info?.enroll_female_trainee), 1),
                                          _createElementVNode("th", _hoisted_51, _toDisplayString(info?.assessed_trainee), 1),
                                          _createElementVNode("th", _hoisted_52, _toDisplayString(info?.assessed_female_trainee), 1),
                                          _createElementVNode("th", _hoisted_53, _toDisplayString(info?.certification_trainee), 1),
                                          _createElementVNode("th", _hoisted_54, _toDisplayString(info?.certification_female_trainee), 1),
                                          _createElementVNode("th", _hoisted_55, _toDisplayString(info?.employment_trainee), 1),
                                          _createElementVNode("th", _hoisted_56, _toDisplayString(info?.employment_female_trainee), 1)
                                        ]))
                                      }), 128))
                                    ], 64))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", _hoisted_57, [
                                    _hoisted_58,
                                    _hoisted_59,
                                    _createElementVNode("th", _hoisted_60, _toDisplayString(Number(this.tolatEnroll).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_61, _toDisplayString(Number(this.tolatEnrollFemale).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_62, _toDisplayString(Number(this.totalAssessed).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_63, _toDisplayString(Number(this.totalAssessedFemale).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_64, _toDisplayString(Number(this.totalCertification).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_65, _toDisplayString(Number(this.totalCertificationFemale).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_66, _toDisplayString(Number(this.totalEmployment).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_67, _toDisplayString(Number(this.totalEmploymentFemale).toLocaleString()), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        ])
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 2)
      ? (_openBlock(), _createElementBlock("div", {
          key: _ctx.notEnComponentKey,
          class: "card"
        }, [
          _createElementVNode("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 2 }]),
                id: "course_batch_summary"
              }, [
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("h4", null, "Course-Batch Training Summary (Course Found: " + _toDisplayString(_ctx.batchSummary.length) + ")", 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_73, [
                    _hoisted_74,
                    _createElementVNode("div", _hoisted_75, [
                      _createElementVNode("div", _hoisted_76, [
                        _createElementVNode("div", _hoisted_77, [
                          (_openBlock(), _createElementBlock("div", {
                            class: "current",
                            "data-kt-stepper-element": "content",
                            key: _ctx.batchkey
                          }, [
                            _createElementVNode("div", _hoisted_78, [
                              _createElementVNode("table", _hoisted_79, [
                                _hoisted_80,
                                _createElementVNode("tbody", _hoisted_81, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchSummary, (data, index) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                      _createElementVNode("tr", _hoisted_82, [
                                        _createElementVNode("th", _hoisted_83, _toDisplayString(index+1) + ". " + _toDisplayString(data?.course_info?.course_name) + "[" + _toDisplayString(data?.course_info?.tranche_info?.short_name) + "] (Total Batch : " + _toDisplayString(data.batch_summary.length) + ")", 1)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.batch_summary, (info, inx) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: inx,
                                          style: {"border-bottom":"1px solid rgba(29, 182, 140, 0.51) !important"}
                                        }, [
                                          _createElementVNode("th", _hoisted_84, _toDisplayString(info?.batch_info?.batch_sequence_number), 1),
                                          _createElementVNode("th", _hoisted_85, _toDisplayString(info?.batch_info?.start_date), 1),
                                          _createElementVNode("th", _hoisted_86, _toDisplayString(info?.batch_info?.end_date), 1),
                                          _createElementVNode("th", _hoisted_87, _toDisplayString(info?.enroll_trainee), 1),
                                          _createElementVNode("th", _hoisted_88, _toDisplayString(info?.enroll_female_trainee), 1),
                                          _createElementVNode("th", _hoisted_89, _toDisplayString(info?.assessed_trainee), 1),
                                          _createElementVNode("th", _hoisted_90, _toDisplayString(info?.assessed_female_trainee), 1),
                                          _createElementVNode("th", _hoisted_91, _toDisplayString(info?.certification_trainee), 1),
                                          _createElementVNode("th", _hoisted_92, _toDisplayString(info?.certification_female_trainee), 1),
                                          _createElementVNode("th", _hoisted_93, _toDisplayString(info?.employment_trainee), 1),
                                          _createElementVNode("th", _hoisted_94, _toDisplayString(info?.employment_female_trainee), 1)
                                        ]))
                                      }), 128)),
                                      _createElementVNode("tr", _hoisted_95, [
                                        _hoisted_96,
                                        _createElementVNode("th", _hoisted_97, _toDisplayString(Number(data?.enroll_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_98, _toDisplayString(Number(data?.enroll_female_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_99, _toDisplayString(Number(data?.assessed_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_100, _toDisplayString(Number(data?.assessed_female_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_101, _toDisplayString(Number(data?.certification_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_102, _toDisplayString(Number(data?.certification_female_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_103, _toDisplayString(Number(data?.employment_trainee).toLocaleString()), 1),
                                        _createElementVNode("th", _hoisted_104, _toDisplayString(Number(data?.employment_female_trainee).toLocaleString()), 1)
                                      ])
                                    ], 64))
                                  }), 128))
                                ]),
                                _createElementVNode("tfoot", null, [
                                  _createElementVNode("tr", _hoisted_105, [
                                    _hoisted_106,
                                    _createElementVNode("th", _hoisted_107, _toDisplayString(Number(this.batchTolatEnroll).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_108, _toDisplayString(Number(this.batchTolatEnrollFemale).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_109, _toDisplayString(Number(this.batchTotalAssessed).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_110, _toDisplayString(Number(this.totalAssessedFemale).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_111, _toDisplayString(Number(this.batchTotalCertification).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_112, _toDisplayString(Number(this.batchTotalCertificationFemale).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_113, _toDisplayString(Number(this.batchTotalEmployment).toLocaleString()), 1),
                                    _createElementVNode("th", _hoisted_114, _toDisplayString(Number(this.batchTotalEmploymentFemale).toLocaleString()), 1)
                                  ])
                                ])
                              ])
                            ])
                          ]))
                        ])
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.load]
  ])
}